import { JsonProperty } from '../../../models/utilities/json-property';

export class UserList {

    public id : number = 0;
    public displayName: string = '';
    public email: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public userPrincipalName : string = '';
    public permissionCount : number = 0;
    public serviceCenterCount : number = 0;
    @JsonProperty({ toType: 'datetime' })
    public lastModified : Date;

    constructor() {
        this.lastModified = new Date();
    }
    
}
